/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VersionType = 'ORIGINAL' | 'APPENDIX' | 'DIGITIZATION' | 'INFLATION_ADJUSTMENT' | 'VALORIZATION_ADJUSTMENT' | 'REPRICE' | 'AUTOMATIC_REPRICE' | 'AUTOMATIC_INFLATION_INCREASE' | 'AUTOMATIC_REPRICE_AND_INFLATION_INCREASE' | 'AUTOMATIC_VALORIZATION' | 'OTHER';

export const VersionType = {
    ORIGINAL: 'ORIGINAL' as VersionType,
    APPENDIX: 'APPENDIX' as VersionType,
    DIGITIZATION: 'DIGITIZATION' as VersionType,
    INFLATION_ADJUSTMENT: 'INFLATION_ADJUSTMENT' as VersionType,
    VALORIZATION_ADJUSTMENT: 'VALORIZATION_ADJUSTMENT' as VersionType,
    REPRICE: 'REPRICE' as VersionType,
    AUTOMATIC_REPRICE: 'AUTOMATIC_REPRICE' as VersionType,
    AUTOMATIC_INFLATION_INCREASE: 'AUTOMATIC_INFLATION_INCREASE' as VersionType,
    AUTOMATIC_REPRICE_AND_INFLATION_INCREASE: 'AUTOMATIC_REPRICE_AND_INFLATION_INCREASE' as VersionType,
    AUTOMATIC_VALORIZATION: 'AUTOMATIC_VALORIZATION' as VersionType,
    OTHER: 'OTHER' as VersionType
};

